import subscriptionsClientAppCreate from './actions/clientAppCreate';
import subscriptionsClientAppsList from './actions/clientAppsList';
import subscriptionsClientAppUpdate from './actions/clientAppUpdate';

import subscriptionsGetClientApps from './getters/getClientApps';
import subscriptionsClientAppsUpload from './mutations/clientAppsUpload';

const actions = {
    subscriptionsClientAppsList,
    subscriptionsClientAppUpdate,
    subscriptionsClientAppCreate
};

const mutations = {
    subscriptionsClientAppsUpload
};

const getters = {
    subscriptionsGetClientApps
};

export default { actions, mutations, getters };
